import withRedirectToApp from './withRedirectToApp';

export default withRedirectToApp;
